export default "__VITE_ASSET__CJwFt75X__"